import { render, staticRenderFns } from "./RenkeInsectStation.vue?vue&type=template&id=4ceca84a&scoped=true"
import script from "./RenkeInsectStation.vue?vue&type=script&lang=js"
export * from "./RenkeInsectStation.vue?vue&type=script&lang=js"
import style0 from "./RenkeInsectStation.vue?vue&type=style&index=0&id=4ceca84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceca84a",
  null
  
)

export default component.exports